// 날짜 및 시간 변환 유틸리티 함수들

/** UTC 인스턴스(ms)에 +9h 후 UTC getter로 읽는 기존 KST 표기 방식과 동일 */
const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

function kstWallPartsFromUtcMs(ms: number): {
  yy: string;
  mm: string;
  dd: string;
  HH: string;
  min: string;
} {
  const kst = new Date(ms + KST_OFFSET_MS);
  const y = kst.getUTCFullYear();
  return {
    yy: String(y).slice(-2),
    mm: String(kst.getUTCMonth() + 1).padStart(2, '0'),
    dd: String(kst.getUTCDate()).padStart(2, '0'),
    HH: String(kst.getUTCHours()).padStart(2, '0'),
    min: String(kst.getUTCMinutes()).padStart(2, '0'),
  };
}

/** ISO 등 문자열 → `yy.mm.dd HH:mm` (KST) */
export const formatDateTimeKST = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    const p = kstWallPartsFromUtcMs(date.getTime());
    return `${p.yy}.${p.mm}.${p.dd} ${p.HH}:${p.min}`;
  } catch {
    return dateString;
  }
};

/** ISO 등 문자열 → `yy.mm.dd` (KST, 시각 없음) */
export const formatDateKST = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    const p = kstWallPartsFromUtcMs(date.getTime());
    return `${p.yy}.${p.mm}.${p.dd}`;
  } catch {
    return dateString;
  }
};

// UTC 시간을 KST(+9시간)로 변환하는 함수
export const convertToKST = (dateString: string): string => {
  return formatDateTimeKST(dateString);
};

/**
 * `YYYY-MM-DD`로 시작하는 값만 `yy.mm.dd`로 표시 (달력·범위 라벨 등, 타임존 보정 없음).
 * 그 외는 원문 반환.
 */
export const formatIsoDateOnlyDisplay = (isoDate: string): string => {
  const m = String(isoDate).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return isoDate;
  return `${m[1].slice(-2)}.${m[2]}.${m[3]}`;
};

// 상대적 시간 표시 (예: "2시간 전", "3일 전")
export const getRelativeTimeKST = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    const kstDate = new Date(date.getTime() + (9 * 60 * 60 * 1000));
    const now = new Date();
    const kstNow = new Date(now.getTime() + (9 * 60 * 60 * 1000));

    const diffMs = kstNow.getTime() - kstDate.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMinutes < 1) {
      return '방금 전';
    } else if (diffMinutes < 60) {
      return `${diffMinutes}분 전`;
    } else if (diffHours < 24) {
      return `${diffHours}시간 전`;
    } else if (diffDays < 30) {
      return `${diffDays}일 전`;
    } else {
      return formatDateKST(dateString);
    }
  } catch (error) {
    console.error('상대 시간 계산 오류:', error);
    return dateString;
  }
};
